import Cookies from 'js-cookie';


export const setCookie = (
  name: string,
  value: string,
  options?: Cookies.CookieAttributes
): void => {
  Cookies.set(name, value, options);
};


export const getCookie = (name: string): string | undefined => {
  return Cookies.get(name);
};

export const getAllCookies = (): { [key: string]: string } => {
  return Cookies.get();
};

export const removeCookie = (
  name: string,
  options?: Cookies.CookieAttributes
): void => {
  Cookies.remove(name, options);
};

export const hasCookie = (name: string): boolean => {
  return Cookies.get(name) !== undefined;
};